import { render } from "./Download.vue?vue&type=template&id=d813356a&scoped=true&ts=true"
import script from "./Download.vue?vue&type=script&lang=ts"
export * from "./Download.vue?vue&type=script&lang=ts"

import "./Download.vue?vue&type=style&index=0&id=d813356a&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d813356a"]])

export default __exports__